import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'bookFields',
    'bookSelect',
    'cadenceSelect',
    'countFields',
    'countInput',
    'practiceFields',
    'practiceSelect',
    'prerequisiteFields',
    'prerequisiteSelect',
    'settingsOutput',
    'teachingFields',
    'teachingSelect',
    'typeSelect'
  ]

  connect () {
    this.refresh()
  }

  refresh () {
    const kind = this.typeSelectTarget.value

    this.bookFieldsTarget.classList.toggle(
      'hidden',
      !['read_complete_book', 'read_from_book'].includes(kind)
    )
    this.countFieldsTarget.classList.toggle('hidden', kind !== 'share_with_group')
    this.practiceFieldsTarget.classList.toggle('hidden', kind !== 'complete_practice')
    this.teachingFieldsTarget.classList.toggle('hidden', kind !== 'complete_teaching')

    const settings = {}

    if (kind === 'complete_practice' && this.hasPracticeSelectTarget) {
      settings.practice_key = this.practiceSelectTarget.value
    }

    if (['read_complete_book', 'read_from_book'].includes(kind) && this.hasBookSelectTarget) {
      settings.book_id = Number.parseInt(this.bookSelectTarget.value || '0', 10)
    }

    if (this.hasPrerequisiteSelectTarget && this.prerequisiteSelectTarget.value) {
      settings.prerequisite_pilgramage_map_step_id = this.prerequisiteSelectTarget.value
    }

    if (kind === 'complete_teaching' && this.hasTeachingSelectTarget) {
      settings.pilgramage_map_teaching_id = this.teachingSelectTarget.value
    }

    if (kind === 'share_with_group' && this.hasCountInputTarget) {
      settings.count = Number.parseInt(this.countInputTarget.value || '1', 10)
    }

    this.settingsOutputTarget.value = JSON.stringify(settings)
  }
}
